import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { user } = useAuth();

  // Signed-in users reach these links from the header profile menu, which is
  // always visible — an in-flow footer is unreachable behind infinite scroll.
  if (user) return null;

  return (
    <footer className="border-t border-border bg-background">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} cannafax.ai a WM MLS, LLC company. All rights reserved.
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <Link
              to="/pricing"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Plans & pricing
            </Link>
            <Link
              to="/customer-agreement"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Customer Agreement
            </Link>

            <Link 
              to="/terms" 
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/refund-policy"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Refund Policy
            </Link>
            <Link
              to="/support"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact Support
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;